import $ from "jquery"
import "./../tools/gmap.coffee"

$ ->

    $infoContent     = $(".archive-addresses .addresses-info")
    $infoSelector    = $(".addresses-info-selector")
    $currentSelector = null

    addressesMap = $(".archive-addresses").gmap

        filters:
            type: ".addresses-types select"

        beforeCreate: (gmap) ->
            size = -> gmap.$map.css "width", $(window).innerWidth() - gmap.$map.offset().left
            size()
            $(window).resize size

            # Bind selector change
            $infoSelector.find("select").change (e) ->
                val = $(e.target).val()
                found = false

                $.each gmap.markers, (i, marker) ->
                    if marker.filters.id == val
                        # center on marker
                        gmap.center [marker], 16

                        # change info content
                        $infoContent.html marker.content
                        $infoContent.fadeIn()

                        found = true

                unless found
                    $infoContent.fadeOut()
                    gmap.center()


        onMarkerClick: (marker, gmap) ->
            $currentSelector.val marker.filters.id
            $currentSelector.change()


        afterFilters: (gmap, markers) ->

            # show the right info selector
            id = gmap.filters.type.value[0]

            $infoSelector.each (i, el) ->
                if $(el).is(".addresses-info-selector--#{id}")
                    $(el).fadeIn()
                    $currentSelector = $(el).find("select")
                    $currentSelector.change()
                else
                    $(el).fadeOut()

            # click on a marker when it's the only one displayed
            if markers.length == 1
                gmap.config.onMarkerClick markers[0], gmap
            else
                unless $currentSelector.val()
                    $infoContent.fadeOut()



// WEBPACK FOOTER //
// ./scripts/modules/addresses.coffee